// extracted by mini-css-extract-plugin
module.exports = {"body":"_1So_8bJdEKNgbM1s8UYSYz"};